export const mapStyles = {
   // https://snazzymaps.com/style/134/light-dream
   1: [
      {
         "featureType": "landscape",
         "stylers": [
            {
               "hue": "#FFBB00"
            },
            {
               "saturation": 43.400000000000006
            },
            {
               "lightness": 37.599999999999994
            },
            {
               "gamma": 1
            }
         ]
      },
      {
         "featureType": "road.highway",
         "stylers": [
            {
               "hue": "#FFC200"
            },
            {
               "saturation": -61.8
            },
            {
               "lightness": 45.599999999999994
            },
            {
               "gamma": 1
            }
         ]
      },
      {
         "featureType": "road.arterial",
         "stylers": [
            {
               "hue": "#FF0300"
            },
            {
               "saturation": -100
            },
            {
               "lightness": 51.19999999999999
            },
            {
               "gamma": 1
            }
         ]
      },
      {
         "featureType": "road.local",
         "stylers": [
            {
               "hue": "#FF0300"
            },
            {
               "saturation": -100
            },
            {
               "lightness": 52
            },
            {
               "gamma": 1
            }
         ]
      },
      {
         "featureType": "water",
         "stylers": [
            {
               "hue": "#0078FF"
            },
            {
               "saturation": -13.200000000000003
            },
            {
               "lightness": 2.4000000000000057
            },
            {
               "gamma": 1
            }
         ]
      },
      {
         "featureType": "poi",
         "stylers": [
            {
               "hue": "#00FF6A"
            },
            {
               "saturation": -1.0989010989011234
            },
            {
               "lightness": 11.200000000000017
            },
            {
               "gamma": 1
            }
         ]
      }
   ],

   // https://snazzymaps.com/style/151/ultra-light-with-labels
   2: [
      {
         "featureType": "water",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#e9e9e9"
            },
            {
               "lightness": 17
            }
         ]
      },
      {
         "featureType": "landscape",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#f5f5f5"
            },
            {
               "lightness": 20
            }
         ]
      },
      {
         "featureType": "road.highway",
         "elementType": "geometry.fill",
         "stylers": [
            {
               "color": "#ffffff"
            },
            {
               "lightness": 17
            }
         ]
      },
      {
         "featureType": "road.highway",
         "elementType": "geometry.stroke",
         "stylers": [
            {
               "color": "#ffffff"
            },
            {
               "lightness": 29
            },
            {
               "weight": 0.2
            }
         ]
      },
      {
         "featureType": "road.arterial",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#ffffff"
            },
            {
               "lightness": 18
            }
         ]
      },
      {
         "featureType": "road.local",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#ffffff"
            },
            {
               "lightness": 16
            }
         ]
      },
      {
         "featureType": "poi",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#f5f5f5"
            },
            {
               "lightness": 21
            }
         ]
      },
      {
         "featureType": "poi.park",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#dedede"
            },
            {
               "lightness": 21
            }
         ]
      },
      {
         "elementType": "labels.text.stroke",
         "stylers": [
            {
               "visibility": "on"
            },
            {
               "color": "#ffffff"
            },
            {
               "lightness": 16
            }
         ]
      },
      {
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "saturation": 36
            },
            {
               "color": "#333333"
            },
            {
               "lightness": 40
            }
         ]
      },
      {
         "elementType": "labels.icon",
         "stylers": [
            {
               "visibility": "off"
            }
         ]
      },
      {
         "featureType": "transit",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#f2f2f2"
            },
            {
               "lightness": 19
            }
         ]
      },
      {
         "featureType": "administrative",
         "elementType": "geometry.fill",
         "stylers": [
            {
               "color": "#fefefe"
            },
            {
               "lightness": 20
            }
         ]
      },
      {
         "featureType": "administrative",
         "elementType": "geometry.stroke",
         "stylers": [
            {
               "color": "#fefefe"
            },
            {
               "lightness": 17
            },
            {
               "weight": 1.2
            }
         ]
      }
   ],

   // https://snazzymaps.com/style/38/shades-of-grey
   3: [
      {
         "featureType": "all",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "saturation": 36
            },
            {
               "color": "#000000"
            },
            {
               "lightness": 40
            }
         ]
      },
      {
         "featureType": "all",
         "elementType": "labels.text.stroke",
         "stylers": [
            {
               "visibility": "on"
            },
            {
               "color": "#000000"
            },
            {
               "lightness": 16
            }
         ]
      },
      {
         "featureType": "all",
         "elementType": "labels.icon",
         "stylers": [
            {
               "visibility": "off"
            }
         ]
      },
      {
         "featureType": "administrative",
         "elementType": "geometry.fill",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 20
            }
         ]
      },
      {
         "featureType": "administrative",
         "elementType": "geometry.stroke",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 17
            },
            {
               "weight": 1.2
            }
         ]
      },
      {
         "featureType": "landscape",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 20
            }
         ]
      },
      {
         "featureType": "poi",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 21
            }
         ]
      },
      {
         "featureType": "road.highway",
         "elementType": "geometry.fill",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 17
            }
         ]
      },
      {
         "featureType": "road.highway",
         "elementType": "geometry.stroke",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 29
            },
            {
               "weight": 0.2
            }
         ]
      },
      {
         "featureType": "road.arterial",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 18
            }
         ]
      },
      {
         "featureType": "road.local",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 16
            }
         ]
      },
      {
         "featureType": "transit",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 19
            }
         ]
      },
      {
         "featureType": "water",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#000000"
            },
            {
               "lightness": 17
            }
         ]
      }
   ],

   // https://snazzymaps.com/style/25/blue-water
   4: [
      {
         "featureType": "administrative",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#444444"
            }
         ]
      },
      {
         "featureType": "landscape",
         "elementType": "all",
         "stylers": [
            {
               "color": "#f2f2f2"
            }
         ]
      },
      {
         "featureType": "poi",
         "elementType": "all",
         "stylers": [
            {
               "visibility": "off"
            }
         ]
      },
      {
         "featureType": "road",
         "elementType": "all",
         "stylers": [
            {
               "saturation": -100
            },
            {
               "lightness": 45
            }
         ]
      },
      {
         "featureType": "road.highway",
         "elementType": "all",
         "stylers": [
            {
               "visibility": "simplified"
            }
         ]
      },
      {
         "featureType": "road.arterial",
         "elementType": "labels.icon",
         "stylers": [
            {
               "visibility": "off"
            }
         ]
      },
      {
         "featureType": "transit",
         "elementType": "all",
         "stylers": [
            {
               "visibility": "off"
            }
         ]
      },
      {
         "featureType": "water",
         "elementType": "all",
         "stylers": [
            {
               "color": "#46bcec"
            },
            {
               "visibility": "on"
            }
         ]
      }
   ],

   // https://snazzymaps.com/style/15/subtle-grayscale
   5: [
      {
         "featureType": "landscape",
         "stylers": [
            {
               "saturation": -100
            },
            {
               "lightness": 65
            },
            {
               "visibility": "on"
            }
         ]
      },
      {
         "featureType": "poi",
         "stylers": [
            {
               "saturation": -100
            },
            {
               "lightness": 51
            },
            {
               "visibility": "simplified"
            }
         ]
      },
      {
         "featureType": "road.highway",
         "stylers": [
            {
               "saturation": -100
            },
            {
               "visibility": "simplified"
            }
         ]
      },
      {
         "featureType": "road.arterial",
         "stylers": [
            {
               "saturation": -100
            },
            {
               "lightness": 30
            },
            {
               "visibility": "on"
            }
         ]
      },
      {
         "featureType": "road.local",
         "stylers": [
            {
               "saturation": -100
            },
            {
               "lightness": 40
            },
            {
               "visibility": "on"
            }
         ]
      },
      {
         "featureType": "transit",
         "stylers": [
            {
               "saturation": -100
            },
            {
               "visibility": "simplified"
            }
         ]
      },
      {
         "featureType": "administrative.province",
         "stylers": [
            {
               "visibility": "off"
            }
         ]
      },
      {
         "featureType": "water",
         "elementType": "labels",
         "stylers": [
            {
               "visibility": "on"
            },
            {
               "lightness": -25
            },
            {
               "saturation": -100
            }
         ]
      },
      {
         "featureType": "water",
         "elementType": "geometry",
         "stylers": [
            {
               "hue": "#ffff00"
            },
            {
               "lightness": -25
            },
            {
               "saturation": -97
            }
         ]
      }
   ],

   // https://snazzymaps.com/style/1/pale-dawn
   6: [
      {
         "featureType": "administrative",
         "elementType": "all",
         "stylers": [
            {
               "visibility": "on"
            },
            {
               "lightness": 33
            }
         ]
      },
      {
         "featureType": "landscape",
         "elementType": "all",
         "stylers": [
            {
               "color": "#f2e5d4"
            }
         ]
      },
      {
         "featureType": "poi.park",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#c5dac6"
            }
         ]
      },
      {
         "featureType": "poi.park",
         "elementType": "labels",
         "stylers": [
            {
               "visibility": "on"
            },
            {
               "lightness": 20
            }
         ]
      },
      {
         "featureType": "road",
         "elementType": "all",
         "stylers": [
            {
               "lightness": 20
            }
         ]
      },
      {
         "featureType": "road.highway",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#c5c6c6"
            }
         ]
      },
      {
         "featureType": "road.arterial",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#e4d7c6"
            }
         ]
      },
      {
         "featureType": "road.local",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#fbfaf7"
            }
         ]
      },
      {
         "featureType": "water",
         "elementType": "all",
         "stylers": [
            {
               "visibility": "on"
            },
            {
               "color": "#acbcc9"
            }
         ]
      }
   ]
};
